//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../GeometricUtilities/GeometricUtilities.AngularPatternSpacing.js";
import "../GeometricUtilities/GeometricUtilities.DistancePatternSpacing.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.HorizontalReference.js";
import "../no/Expression.js";
let d=[[[1,"AngularSpacing",0,"GeometricUtilities.AngularPatternSpacing",0],[1,"AxialSpacing",0,"GeometricUtilities.DistancePatternSpacing",0],[1,"ConicalAngle",0,"Expression",0],[0,"CreateLastStaggered",1,0],[1,"HorizontalRef",0,"GeometricUtilities.HorizontalReference",0],[0,"MeasureDistanceType",1,0],[0,"RotationAxis",1,"Axis",0],[0,"RotationCenter",1,"Point",0],[0,"StaggerType",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.AxialPattern = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.AxialPattern";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.AxialPattern.StaggerOptions = Object.freeze({
    "None" : "None", "Row" : "Row", "Column" : "Column"});

SPLM.GeometricUtilities.AxialPattern.MeasureDistanceOption = Object.freeze({
    "AlongAxis" : "AlongAxis", "AlongAngle" : "AlongAngle"});

export default SPLM;